import React, { Component } from "react";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";
import Header from "../../components/UI/Header/Header";
import { backendBaseUri } from "../../uri";

import CompleteForms from "../../components/Forms/CompleteForms/CompleteForms";
import axios from "axios";

import classes from "./completedlist.css";

class CompletedList extends Component {
    componentDidMount() {
        axios
            .get(`${backendBaseUri}/complete`, {
                headers: {
                    "x-auth": localStorage.getItem("token"),
                },
            })
            .then((res) => {
                this.props.onFormListLoad(res.data.completed);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    handleClickCompleteConsent(id) {
        // const { consentForms } = this.props
        // let completeForm = consentForms[id]
        // this.props.onDisplayForm(completeForm)
    }

    render() {
        const { consentForms } = this.props;
        return (
            <div>
                <header>
                    <Header />
                </header>
                <div className={classes.MainContainer}>
                    <div className={classes.ListSection}>
                        <h2>Completed Forms</h2>
                        {consentForms.length > 0 && (
                            <CompleteForms
                                forms={consentForms}
                                // handleClickCompleteConsent={this.handleClickCompleteConsent.bind(this)}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        consentForms: state.formBuilder.consentForms,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFormListLoad: (forms) => dispatch(actions.fetchForms(forms)),
        onDisplayForm: (form) => dispatch(actions.fetchForm(form)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CompletedList);



// WEBPACK FOOTER //
// ./src/containers/CompletedList/CompletedList.js